module.exports = __webpack_public_path__ + "static/logoWhite-fbd429b77641f20bdd9cdcad55a95d4c.svg";